<script setup lang="ts">
interface HotelFiltersSectionProps {
  borderSeparator: boolean;
  title?: string;
}

const props = defineProps<HotelFiltersSectionProps>();
</script>

<template>
  <div
    class="hotel-filters-section"
    :class="{ 'border-separator': props.borderSeparator }"
  >
    <div v-if="props.title" class="title">{{ props.title }}</div>
    <slot />
  </div>
</template>

<style scoped lang="scss">
.hotel-filters-section {
  padding-bottom: var(--spacing-32);

  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);

  &.border-separator {
    border-bottom: 1px solid var(--color-neutral-30);
    margin-bottom: var(--spacing-32);
  }

  .title {
    @include font-label-l-bold;
    color: var(--color-neutral-70);
  }
}
</style>
